import { render, staticRenderFns } from "./ViewRow.vue?vue&type=template&id=bd7c8704&scoped=true"
import script from "./ViewRow.vue?vue&type=script&lang=js"
export * from "./ViewRow.vue?vue&type=script&lang=js"
import style0 from "./ViewRow.vue?vue&type=style&index=0&id=bd7c8704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7c8704",
  null
  
)

export default component.exports